export default __webpack_public_path__ + "abc1dc724cbf5cd63374209d0f09a3ae.png";